import React from 'react';

export const CheckIcon = ({ transparent = false, ...rest }) =>
  transparent ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="currentColor"
      color="#37BB7C"
      {...rest}
    >
      <g>
        <path d="M16 0C12.8355 0 9.74207 0.938384 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87707C0.00693258 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5514 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0ZM25.24 10.9333L16.1067 23.32C16.0004 23.4648 15.8659 23.5867 15.7114 23.6783C15.5569 23.7698 15.3854 23.8293 15.2073 23.8529C15.0292 23.8766 14.8482 23.864 14.6751 23.816C14.502 23.7679 14.3404 23.6854 14.2 23.5733L7.68001 18.36C7.54304 18.25 7.42917 18.114 7.34493 17.9598C7.2607 17.8056 7.20777 17.6363 7.18919 17.4616C7.1706 17.2869 7.18673 17.1102 7.23663 16.9418C7.28654 16.7733 7.36925 16.6164 7.48001 16.48C7.70156 16.2111 8.01955 16.0397 8.36592 16.0023C8.71229 15.9649 9.05953 16.0646 9.33334 16.28L14.7733 20.6267L23.0933 9.33333C23.3033 9.05219 23.6156 8.86514 23.9625 8.81272C24.3094 8.76031 24.6631 8.84676 24.9467 9.05333C25.0907 9.15648 25.2127 9.28728 25.3056 9.43811C25.3985 9.58894 25.4604 9.75677 25.4877 9.9318C25.515 10.1068 25.5072 10.2855 25.4647 10.4575C25.4221 10.6295 25.3458 10.7912 25.24 10.9333Z" />
      </g>
    </svg>
  ) : (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <circle cx="12" cy="12" r="12" fill="#37BB7C"></circle>
          <path
            fill="none"
            stroke="#fff"
            d="M6.05 12.1l3.55 3.6 8.35-8.4"
          ></path>
        </g>
      </g>
    </svg>
  );
